
import React from "react";

const TextModal = ({ text, onClose }) => {
  if (!text) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className="relative max-w-4xl w-full max-h-[80vh] bg-gradient-to-br from-slate-900/95 via-blue-900/95 to-cyan-900/95 
          backdrop-blur-xl rounded-2xl border border-white/20 shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 px-6 py-4 flex items-center justify-between">
          <h2 className="text-xl font-bold text-white flex items-center gap-2">
            <span>📄</span> Details
          </h2>
          <button 
            onClick={onClose} 
            className="w-8 h-8 bg-white/20 hover:bg-red-500 text-white rounded-lg 
              flex items-center justify-center transition-all duration-300"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[60vh]">
          <div className="text-white/90 text-base whitespace-pre-wrap leading-relaxed">
            {text}
          </div>
        </div>
        
        {/* Footer */}
        <div className="px-6 py-4 border-t border-white/10">
          <button 
            onClick={onClose}
            className="w-full bg-gradient-to-r from-blue-500 to-cyan-500 text-white py-3 rounded-xl
              font-semibold hover:from-blue-600 hover:to-cyan-600 transition-all duration-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TextModal;
